import styled from 'styled-components';
import { A } from 'components/Typography';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Ul = styled.ul`
  padding-left: 40px;
`;

export const Li = styled.li`
  margin-top: 12px;
`;

export const Warning = styled.p`
  font-weight: bold;
  color: ${th('colors.red')};
  margin: 0;
  margin-bottom: 20px;
`;

export const Info = styled.p`
  line-height: 24px;
  align-self: center;
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 32px 0;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
  }

  @media ${sizes.desktop} {
    margin: 16px 0;
  }
`;

export const ContactInformation = styled.div`
  flex: 3;
  max-width: 650px;

  @media ${sizes.tabletPortrait} {
    margin-right: 40px;
  }

  @media ${sizes.desktop} {
    margin: 40px;
  }
`;

export const FollowUsOn = styled.div`
  flex: 1;
  max-width: 250px;
  min-width: 150px;
  margin-top: 40px;

  @media ${sizes.tabletPortrait} {
    margin-left: 40px;
    margin-top: 0;
  }

  @media ${sizes.desktop} {
    margin: 40px;
  }
`;

export const SocialLink = styled(A)`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-top: 16px;
  color: ${th('colors.white')};

  > svg {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
`;

export const IntercomLink = styled.span`
  color: ${th('colors.primaryLink.default')};
  text-decoration: underline;
  cursor: pointer;
  :hover {
    color: ${th('colors.primaryLink.hover')};
  }
`;

export const StyledContactListItem = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  color: ${th('colors.black')};
  align-items: stretch;

  > p {
    margin: 10px;
  }

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    min-height: 100px;
  }

  :not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const ContactIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 10px;
  background-color: ${th('colors.white')};
  box-shadow: ${th('shadows.small')};
  width: 100%;
  min-height: 64px;

  @media ${sizes.tabletPortrait} {
    padding: 20px;
    width: 100px;
  }
`;

export const IconImage = styled.img`
  width: 45px;

  @media ${sizes.tabletPortrait} {
    width: 55px;
  }
`;

export const Accordions = styled.div`
  margin: 40px 0;

  @media ${sizes.tabletPortrait} {
    margin: 40px 0 60px 0;
  }
`;

export const InfoSection = styled.div`
  margin: 16px 0;
`;
